import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { AlignItemsProps, BorderRadiusProps, JustifyContentProps } from 'styled-system';
import { alignItems, borderRadius, justifyContent, themeGet } from 'styled-system';

import type { CursorProps, ThemeHeightProps, ThemeWidthProps } from '../../theme/system-utilities';
import { cursor, themeHeight, themeWidth } from '../../theme/system-utilities';
import { ButtonBase } from './Base';

const UnstyledIconButton = styled(ButtonBase)<
  JustifyContentProps &
    AlignItemsProps &
    ThemeHeightProps &
    ThemeWidthProps &
    CursorProps &
    BorderRadiusProps
>`
  ${justifyContent};
  ${alignItems}
  ${themeHeight};
  ${themeWidth};
  ${cursor};
  ${borderRadius};

  &:focus-visible {
    outline-offset: -${themeGet('space.sp_4')}px;
  }
`;

export const IconButton = (props: ComponentProps<typeof UnstyledIconButton>) => (
  <UnstyledIconButton
    themeHeight="sp_48"
    themeWidth="sp_48"
    cursor="pointer"
    alignItems="center"
    justifyContent="center"
    borderRadius="circle"
    {...props}
  />
);
